import React from "react";
import { Review } from "@scrile/api-provider/dist/api/ReviewProvider";
import useViewController from "./viewController";
import ActionStatus from "../../components/ActionStatus";
import BaseButton from "../../components/BaseButton";
import BaseForm from "../../components/BaseForm";
import ContentHeader from "../../components/ContentHeader";
import ModalWindow from "../../components/ModalWindow";
import { useTranslation } from "../../locales";
import "./style.scss";

interface Props {
  show: boolean;
  onClose: () => void;
  appointmentId: string;
  onFeedbackAdded?: (review: Review) => void;
}

export default function LeaveCoachFeedbackModal({ show, onClose, appointmentId, onFeedbackAdded }: Props) {
  const {
    fields,
    values,
    errors,
    onChange,
    setErrors,
    onPublishFeedback,
    processing,
    showSuccessStatus,
    onCloseModal,
  } = useViewController(appointmentId, onClose, onFeedbackAdded);
  const { t } = useTranslation();

  return (
    <ModalWindow className="leave-coach-feedback-modal" show={show} onClose={onCloseModal}>
      {showSuccessStatus ? (
        <ActionStatus
          status="success"
          title={t("Feedback is published")}
          className="leave-coach-feedback-modal__success"
          description={t("Your feedback is visible to the candidate only.")}
        >
          <BaseButton className="mt-6" name="awesome" onClick={onCloseModal} fluid large>
            {t("Awesome")}
          </BaseButton>
        </ActionStatus>
      ) : (
        <BaseForm
          className="leave-coach-feedback-modal__form"
          fields={fields}
          values={values}
          errors={errors}
          setErrors={setErrors}
          onChange={onChange}
          headline={
            <>
              <ContentHeader>{t("Leave a feedback")}</ContentHeader>
              <div className="leave-coach-feedback-modal__hint body mb-4">{t("Visible to candidate only")}</div>
            </>
          }
        >
          <div className="leave-coach-feedback-modal__buttons d-flex">
            <BaseButton className="leave-coach-feedback-modal__btn" onClick={onCloseModal} outline large>
              {t("Cancel")}
            </BaseButton>
            <BaseButton
              name="submit"
              className="leave-coach-feedback-modal__btn"
              onClick={onPublishFeedback}
              large
              loading={processing}
            >
              {t("Publish")}
            </BaseButton>
          </div>
        </BaseForm>
      )}
    </ModalWindow>
  );
}
